import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { Formik } from 'formik';
import isEmpty from 'lodash/isEmpty';
import { dataURLtoFile, getIpGlobal } from 'utils/utils';
import {
  getOneToOneSelfBookClient,
  getSingleContract,
  saveSignoffData,
  setSignedContract,
} from 'services/contributions.service';
import { PhoneInput } from 'react-international-phone';
import Checkbox from '@material-ui/core/Checkbox';
import { useIsEmailExist } from 'utils/useIsEmailExist';
import { getPurchaseValidationSchema } from 'utils/validation';
import { useAccount, useApplicationStatus, useClientPreview, useHttp, useRouter } from 'hooks';
import { If, mapTo } from 'utils/fp';
import { login, completeRegister, LOG_IN_FAILURE, REGISTER_FAILURE, CONTINUE_REGISTER_FAILURE } from 'actions/user';
import * as purchaseService from 'services/purchase.service';
import Modal from 'components/UI/Modal';
import { LabelText } from 'components/UI/Text/TextStyles';
import { ContributionPurchaseType, ContributionType, PaymentStatus, UserRoles } from 'helpers/constants';
import { fetchClientContribution, FETCH_CONTRIBUTION_SUCCESS, fetchContributionActions } from 'actions/contributions';
import { ModalTermsAndConditions } from 'components/Modals/TermsAndConditions';
import { determineColorToUse, joinContribution } from 'services/contributions.service';
import isNil from 'lodash/isNil';
import * as contributionActions from 'actions/contributions';
import useContribution from '../../hooks/useContribution';
import { redirectTo } from 'services/links';
import {
  PURCHASE_MODAL_STEPS,
  PURCHASE_MODAL_TITLES,
  ACCOUNT_FORM_FIELDS,
  DISCOUNT_CODE_FIELDS,
} from './PurchaseModal.constants';
import { PurchaseModalForm } from './PurchaseModalForm';
import { CustomPurchaseModalForm } from './CustomPurchaseModalForm';
import { PAYMENT_OPTIONS, JOIN_CONTRIBUTION_STATUS, ROUTES } from '../../../../constants';
import { SuccessfulPurchaseModal } from 'components/Modals/SuccessfulPurchaseModal';
import { FailedPurchaseModal } from 'components/Modals/FailedPurchaseModal';
import { PAYMENTS_STATUS } from '../PurchaseMembershipModal/PurchaseModal.constants';
import styled from 'styled-components';
import CreateCustomWaiver from 'pages/CreateContribution/components/CreateCustomWaiver';
import easyBooking from 'reducers/easyBooking.reducer';
import { editUserProfile } from 'services/user.service';
import { updateUser } from 'actions/update-user';
import useApplyContributionView from 'hooks/useApplyContributionView';

const StyledPurchaseModalContainer = styled.div`
  ${({ clientPreviewMode }) =>
    clientPreviewMode &&
    `
 pointer-events: none;
  
`}
`;

const StyledPhoneInput = styled(PhoneInput)`
  width: ${({ mobileView }) => (mobileView ? '100%' : '60%')};
  gap: 10px;
  &.phone-error {
    .react-international-phone-input {
      border-color: red;
    }
  }
  .react-international-phone-country-selector {
    .react-international-phone-country-selector-button {
      padding: 10px 6px;
      height: auto;
      border-radius: 10px;
    }
  }
  .react-international-phone-input {
    width: 100%;
    padding: 10px 10px;
    height: auto;
    border-radius: 10px;
    font-size: 14px;
  }
`;

const CustomPurchaseModal = ({
  isOpen,
  onClose,
  onSubmit,
  typeOfPayment,
  oneToOne,
  paymentDataOneToOne,
  isPackage,
  isMonthlySessionSubscription,
  perSessionStyled,
  sessionPackageStyled,
  monthlySessionSubscription,
  proseedHandlePurchase,
  updatePackageIntent,
  submitNow,
  anyPaymentOptionEnabled,
  showOnlyProseedModal,
  handleUrlModal = true,
  step,
  setStep,
  handleOpenPackagePurchased,
  isCouponAvailable,
  invitedClientData,
  easyBookingState = false,
  rescheduleSession = false,
  setRescheduleSession,
  packageSessionBooking = false,
  setShowModal = () => {},
  isModal = false,
  setRescheduleBookingmodal = () => {},
}) => {
  const [couponError, setCouponError] = useState(false);
  const { clientPreviewMode } = useClientPreview();
  const [showTerms, setShowTerms] = useState(false);
  const [allowpassword, setallowpassword] = useState(false);
  const [isWaiverVisible, setIsWaiverVisible] = useState(false);
  const [newUserSignedIn, setNewUserSignedIn] = useState(false);
  const [selectedTimeZone, setselectedTimeZone] = useState(null);
  const [showUnableJoin, setshowUnableJoin] = useState(false);
  const [waiverData, setWaiverData] = useState(null);
  const [loginErrorMessage, setLoginErrorMessage] = useState('');
  const [smsReminderCheckBox, setSmsReminderCheckBox] = useState(true);
  const [showPhoneNumberFields, setshowPhoneNumberFields] = useState(true);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [loginStep, setloginStep] = useState(false);
  const [phoneNumberField, setPhoneNumberField] = useState('');
  const [timeZoneArray, setTimeZoneArray] = useState([]);
  const [statesArray, setStatesArray] = useState([]);
  const [ip, setIP] = useState('119.152.140.119');
  const couponCode = useSelector(state => state?.contributions?.couponCode);
  const { query, history, location, domain } = useRouter();
  const queryCode = query?.code === undefined ? null : query?.code?.includes('p_') ? null : query?.code;
  const [paramsforEditUser, setParamsforEditUser] = useState({
    countryId: null,
    TimeZoneId: null,
    stateCode: null,
  });
  const { payment } = query;
  const [isAlreadyPuchased, setIsAlreadyPuchased] = useState(false);
  const [isFreePackageFailed, setIsFreePackagePuchased] = useState(false);
  const { currentRole } = useAccount();
  const isCoach = currentRole === UserRoles.cohealer;
  const priceId = useSelector(state => state.contributions.priceCode);
  const { timeZones, loading: timeZoneLoading } = useSelector(state => state.timeZone);
  const { states } = useSelector(state => state?.states);
  const { countries, loading: countriesLoading } = useSelector(state => state?.country);
  const isLoadingAccount = useSelector(({ account }) => account.isLoading);
  const errorAccount = useSelector(({ account }) => account.error?.message);
  const errorContribution = useSelector(({ contributions }) => contributions.error?.message);
  const isInviteToJoin = useSelector(state => state.contributions.inviteCode);
  const isCodeToJoin = useSelector(state => state?.contributions?.singleCode);
  const [errorModal, setErrorModal] = useState(false);
  const [singleSessionInvite, setSingleSessionInvite] = useState(null);
  const [isSigned, setIsSigned] = useState(null);
  const [enrollmentFormSubmitted, setEnrollmentFormSubmitted] = useState(false);
  const firstRender = useRef(true);
  function isCountryNameAvailable(countryName, arrayOfObjects) {
    return arrayOfObjects.some(obj => obj.countryName === countryName);
  }
  useEffect(() => {
    if (isCodeToJoin) {
      getSelfBookData();
    }
    if (!isEmpty(user)) {
      if (contribution?.smsPermissionsPerContribution?.SessionReminder === true) {
        if (
          !isEmpty(user.subCategorySmsPermissions) &&
          !isEmpty(contribution.subCategorySmsPermissionsPerContribution) &&
          ((user?.subCategorySmsPermissions?.OneHourSession === true &&
            contribution?.subCategorySmsPermissionsPerContribution?.OneHourSession === true) ||
            (user?.subCategorySmsPermissions?.TwentyFourHourSession === true &&
              contribution?.subCategorySmsPermissionsPerContribution?.TwentyFourHourSession === true))
        ) {
          setshowPhoneNumberFields(true);
          setloginStep(true);
        }
      } else {
        setshowPhoneNumberFields(false);
      }
    } else {
      if (contribution?.smsPermissionsPerContribution?.SessionReminder === true) {
        setshowPhoneNumberFields(true);
      } else {
        setshowPhoneNumberFields(false);
      }
    }
  }, []);
  useEffect(() => {
    if (isEmpty(user) === false) {
      if (contribution.paymentType === 'Simple' && contribution.taxType != 'No' && isInviteToJoin === null) {
        checkProceedStatus();
      }
    }
  }, []);
  const getSelfBookData = () => {
    getOneToOneSelfBookClient(isCodeToJoin.slice(2)).then(response => {
      setSingleSessionInvite(response);
    });
  };
  const dispatch = useDispatch();
  const clearUrlSearch = () => {
    history.replace({
      search: '',
    });
  };

  const getWaiverForm = async () => {
    let email = ' ';

    try {
      getSingleContract(contribution?.id, email).then(data => {
        setWaiverData({
          ...waiverData,
          formName: data?.formName,
          formDescription: data?.formDescription,
          formText: data?.formText,
          description: data?.formDescription,
          templateId: data.id,
          id: data.id,
          completeDescription: data?.formText,
        });
        setIsWaiverVisible(true);
      });
    } catch (e) {}
  };
  const [isSuccessPurchaseModalOpen, setIsSuccessPurchaseModalOpen] = useState(
    handleUrlModal && payment === PAYMENTS_STATUS.SUCCESS,
  );
  const [isFailedPurchaseModalOpen, setIsFailedPurchaseModalOpen] = useState(
    handleUrlModal && payment === PAYMENTS_STATUS.FAILED,
  );
  const handleSuccessModalClose = useCallback(() => {
    setIsSuccessPurchaseModalOpen(false);
    clearUrlSearch();
  }, []);
  const handleFailedModalClose = useCallback(() => {
    setIsFailedPurchaseModalOpen(false);
    clearUrlSearch();
  }, []);

  const contribution = useContribution();
  const { user } = useAccount();
  const {
    applicationRequiredButNotApproved,
    isApplicationResponsePending,
    isApplicationNeedsToBeSubmitted,
  } = useApplicationStatus({
    contribution,
    user,
  });
  const { isApplyContributionView } = useApplyContributionView();

  const {
    type,
    id,
    title,
    paymentInfo: { paymentOptions },
    isElectronicSignatureActive,
  } = contribution;

  // const modalTitle = isInviteToJoin
  //   ? PURCHASE_MODAL_TITLES[type]?.join(title, !isEmpty(user))
  //   : PURCHASE_MODAL_TITLES[type]?.modal;

  // const [step, setStep] = useState(() => {
  //   if (!isNil(isInviteToJoin)) {
  //     return PURCHASE_MODAL_STEPS.join;
  //   }
  //   if (!isEmpty(user)) {
  //     return PURCHASE_MODAL_STEPS.loggedIn;
  //   }
  //   return PURCHASE_MODAL_STEPS.init;
  // });

  const [lastStep, setLastStep] = useState(step);

  const { checkEmail, isLoadingEmail } = useIsEmailExist();

  const formRef = useRef(null);

  const handleCloseAlreadyPurchased = () => {
    setIsAlreadyPuchased(false);
    onClose();
  };
  const handleClosePackagePurchased = () => {
    setIsFreePackagePuchased(false);
  };

  useEffect(() => {
    if (submitNow) {
      // eslint-disable-next-line no-unused-expressions
      formRef.current?.handleSubmit();
    }
  }, [submitNow]);

  useEffect(() => {
    (async () => {
      const res = await fetch('https://api.ipify.org/?format=json');
      const data = await res.json();
      setIP(data.ip);
    })();
  }, []);

  const handleProceedPurchaseStatus = useCallback(async () => {
    const userIp = await getIpGlobal();
    const action = await fetchClientContribution(id, userIp)(dispatch);
    if (action.type === FETCH_CONTRIBUTION_SUCCESS) {
      const isProceedStatus = [PaymentStatus.requiresAction, PaymentStatus.requiresConfirmation].includes(
        action.payload.purchaseStatus,
      );
      if (isProceedStatus) {
        return showOnlyProseedModal();
      }
    } else {
      return null;
    }
  }, [dispatch, id, showOnlyProseedModal]);

  const isSignSaved = async signature => {
    let isSignedSubmitted = null;
    if (!isCoach) {
      if (contribution?.customWaiverId != null) {
        isSignedSubmitted = await submitUserSignature(signature);
      } else {
        isSignedSubmitted = await saveSignature(signature);
      }
    }
    return isSignedSubmitted;
  };

  const submitUserSignature = async val => {
    let isSignedSubmitted = false;
    setLoadingPayment(true);
    const formData = new FormData();
    const sign = dataURLtoFile(val);
    formData.append('file', sign);
    const userIP = await getIpGlobal();
    const details = {
      contributionId: contribution.id,
      contractId: contribution.customWaiverId,
      ipAddress: userIP,
    };
    try {
      setSignedContract(formData, details);
      isSignedSubmitted = true;
    } catch (e) {
      isSignedSubmitted = false;
    }
    setLoadingPayment(false);
    return isSignedSubmitted;
  };

  const checkPhoneNumber = () => {
    if (!isEmpty(user)) {
      if (!isEmpty(user.globalSmsPermissions) && user.globalSmsPermissions.SessionReminder === true) {
        if (
          !isEmpty(user.subCategorySmsPermissions) &&
          !isEmpty(contribution.subCategorySmsPermissionsPerContribution) &&
          ((user?.subCategorySmsPermissions?.OneHourSession === true &&
            contribution?.subCategorySmsPermissionsPerContribution?.OneHourSession === true) ||
            (user?.subCategorySmsPermissions?.TwentyFourHourSession === true &&
              contribution?.subCategorySmsPermissionsPerContribution?.TwentyFourHourSession === true))
        ) {
          if (step === 'login' && loginStep === false) {
            setshowPhoneNumberFields(true);
            setloginStep(true);
            // return false;
          }
          if (smsReminderCheckBox === true) {
            if (user?.phoneNo === null || user.phoneNo?.length === 0) {
              if (phoneNumberField.length === 0) {
                setshowPhoneNumberFields(true);
                return false;
              } else {
                if (user?.phoneNo != phoneNumberField) {
                  updatePhoneNumber();
                }
                setshowPhoneNumberFields(false);
                return true;
              }
            } else {
              if (user?.phoneNo != phoneNumberField && phoneNumberField.length > 0) {
                setShowErrorMessage(false);
                updatePhoneNumber();
              } else if (phoneNumberField.length > 0) {
                setShowErrorMessage(false);
                setshowPhoneNumberFields(true);
                return true;
              } else {
                setShowErrorMessage(true);
                setshowPhoneNumberFields(true);
                return false;
              }
              setshowPhoneNumberFields(false);
              return true;
            }
          } else {
            return true;
          }
        } else {
          setshowPhoneNumberFields(false);
          return true;
        }
      } else {
        setshowPhoneNumberFields(false);
        return true;
      }
    } else {
      if (contribution?.smsPermissionsPerContribution?.SessionReminder === true) {
        setshowPhoneNumberFields(true);
      } else {
        setshowPhoneNumberFields(false);
      }

      if (showPhoneNumberFields === true && phoneNumberField.length > 0) {
        return true;
      } else if (showPhoneNumberFields === false) {
        return true;
      } else {
        return false;
      }

      return true;
    }
  };
  const updatePhoneNumber = async () => {
    await request('/Account/UpdatePhoneNo', 'POST', {
      phoneNumber: phoneNumberField,
    }).then(res => {
      let u = {
        ...user,
        phoneNo: phoneNumberField,
      };
      dispatch(updateUser(u));
    });
  };

  const checkCountry = async values => {
    const res = await fetch('https://geolocation-db.com/json/');
    const data = await res.json();
    const currentCountry = countries.find(obj => obj.name === data.country_name);
    // const currentCountry = { id: '60b8ddb57205057e7ce2b861' };

    if (currentCountry.id != formRef.current.values.countryId) {
      if (currentCountry.id === '60b8ddb57205057e7ce2b861') {
        const filteredStates = states.filter(obj => obj.countryId === formRef.current.values.countryId);
        formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
        setStatesArray(filteredStates);
        setTimeZoneArray(timeZones);
        if (
          formRef?.current?.values?.TimeZoneId?.length > 0 &&
          formRef?.current?.values?.TimeZoneId != null &&
          formRef?.current?.values?.stateCode?.length > 0 &&
          formRef?.current?.values?.stateCode != null
        ) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, values.TimeZoneId);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, values.stateCode);
        } else {
          return false;
        }
        return true;
      } else {
        const filteredTimezone = timeZones.filter(obj => obj?.countryId === currentCountry.id);
        if (filteredTimezone.length === 1) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, filteredTimezone[0].countryName);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(filteredTimezone);
          setLoadingPayment(false);
          setParamsforEditUser({
            countryId: formRef.current.values.countryId,
            TimeZoneId: filteredTimezone[0].countryName,
            stateCode: null,
          });
          return true;
        } else if (filteredTimezone.length > 1) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(filteredTimezone);
          setParamsforEditUser({ countryId: currentCountry.id, TimeZoneId: null, stateCode: null });
          setLoadingPayment(false);
          if (formRef?.current?.values?.TimeZoneId?.length > 0 && formRef?.current?.values?.TimeZoneId != null) {
            let checkTimeZone = isCountryNameAvailable(formRef.current.values.TimeZoneId, filteredTimezone);
            if (checkTimeZone) {
              formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, formRef.current.values?.TimeZoneId);
              return true;
            } else if (values.TimeZoneId.length > 0 && values.TimeZoneId != null) {
              let checkTimeZoneValue = isCountryNameAvailable(values.TimeZoneId, filteredTimezone);
              if (checkTimeZoneValue) {
                formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, values.TimeZoneId);
                return true;
              } else {
                formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, null);
                return false;
              }
            } else {
              formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, null);
              return false;
            }
          } else {
            return false;
          }
          return true;
        } else if (filteredTimezone.length === 0) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(timeZones);
          setParamsforEditUser({ countryId: currentCountry.id, TimeZoneId: null, stateCode: null });
          setLoadingPayment(false);
          if (formRef?.current?.values?.TimeZoneId?.length > 0 && formRef?.current?.values?.TimeZoneId != null) {
            formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, formRef.current.values.TimeZoneId);
          } else {
            return false;
          }
          return true;
        }
      }
    } else {
      if (formRef.current.values.countryId === '60b8ddb57205057e7ce2b861') {
        formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, formRef.current.values.countryId);
        const filteredStates = states.filter(obj => obj.countryId === formRef.current.values.countryId);
        setStatesArray(filteredStates);
        if (formRef?.current?.values?.stateCode?.length > 0 && formRef?.current?.values?.stateCode != null) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, formRef.current.values.stateCode);
        } else {
          setLoadingPayment(false);
          return false;
        }
        if (formRef?.current?.values?.TimeZoneId?.length > 0 && formRef?.current?.values?.TimeZoneId != null) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, formRef.current.values.TimeZoneId);
        } else {
          setLoadingPayment(false);
          return false;
        }
        return true;
      } else {
        const filteredTimezone = timeZones.filter(obj => obj?.countryId === formRef.current.values.countryId);
        if (filteredTimezone.length === 1) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, formRef.current.values?.countryId);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, filteredTimezone[0]?.countryName);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(filteredTimezone);
          setLoadingPayment(false);
          setParamsforEditUser({
            countryId: formRef.current.values.countryId,
            TimeZoneId: filteredTimezone[0].countryName,
            stateCode: null,
          });
          return true;
        } else if (filteredTimezone.length > 1) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, formRef.current.values?.countryId);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(filteredTimezone);
          setParamsforEditUser({ countryId: values?.countryId, TimeZoneId: null, stateCode: null });
          setLoadingPayment(false);

          if (formRef.current.values.TimeZoneId.length > 0 && formRef.current.values.TimeZoneId != null) {
            let checkTimeZone = isCountryNameAvailable(formRef.current.values.TimeZoneId, filteredTimezone);
            if (checkTimeZone) {
              formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, formRef.current.values?.TimeZoneId);
              return true;
            } else if (values.TimeZoneId.length > 0 && values.TimeZoneId != null) {
              let checkTimeZoneValue = isCountryNameAvailable(values.TimeZoneId, filteredTimezone);
              if (checkTimeZoneValue) {
                formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, values.TimeZoneId);
                return true;
              } else {
                formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, null);
                return false;
              }
            } else {
              formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, null);
              return false;
            }
          } else {
            return false;
          }
          return true;
        } else if (filteredTimezone.length === 0) {
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
          formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, null);
          setTimeZoneArray(timeZones);
          setParamsforEditUser({ countryId: currentCountry.id, TimeZoneId: null, stateCode: null });
          setLoadingPayment(false);
          if (formRef?.current?.values?.TimeZoneId?.length > 0 && formRef?.current?.values?.TimeZoneId != null) {
            formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, formRef.current.values.TimeZoneId);
          } else {
            return false;
          }
          return true;
        }
      }
    }
  };
  const checkProceedStatus = async () => {
    if (!isEmpty(user)) {
      formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, user.countryId);
      formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, user.timeZoneId);
      formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, user.stateCode);
      const res = await fetch('https://geolocation-db.com/json/');
      const data = await res.json();
      const currentCountry = countries.find(obj => obj.name === data.country_name);
      // const currentCountry = { id: '60b8ddb57205057e7ce2b861' };
      const filteredTimezone = timeZones.filter(obj => obj?.countryId === currentCountry.id);
      const filteredObjects = states.filter(obj => obj.countryId === currentCountry.id);
      setStatesArray(filteredObjects);
      formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, currentCountry.id);
    }
  };

  const stepVerifier = useCallback(
    async values => {
      let { Signature } = values;
      if (isSigned !== null) {
        Signature = isSigned;
      }
      if (!isEmpty(user)) {
        // if (contribution.paymentType === 'Simple' && contribution.taxType != 'No' && isInviteToJoin === null) {
        //   formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.country, user?.countryId);
        //   setselectedTimeZone(user.timeZoneId);
        //   formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.timeZoneId, user?.timeZoneId);
        //   formRef.current.setFieldValue(ACCOUNT_FORM_FIELDS.state, user?.stateCode);
        // }
        if (user?.id === contribution?.userId && paymentOptions != PAYMENT_OPTIONS.FREESESSIONPACKAGE) {
          history.push(ROUTES.ROLE_SWITCH, { path: location.pathname, domain: domain });
          // setshowUnableJoin(true);
          return false;
        }
        // if (contribution?.type === ContributionType.contributionOneToOne) {
        //   setLastStep(step);
        //   setStep(PURCHASE_MODAL_STEPS.loggedIn);
        //   return false;
        // }
        if (
          (contribution?.isCustomEnrollmentFormAdded ||
            (contribution?.isPhoneNumberAdded && contribution?.enrollmentFormViewModel?.questions?.length > 0)) &&
          !enrollmentFormSubmitted &&
          step !== PURCHASE_MODAL_STEPS.enrollmentForm
        ) {
          setStep(PURCHASE_MODAL_STEPS.enrollmentForm);
          return false;
        }
        if (
          isElectronicSignatureActive &&
          contribution.customWaiverId === null &&
          Signature &&
          step === PURCHASE_MODAL_STEPS.loggedIn
        ) {
          const signSaved = await isSignSaved(Signature);
          if (signSaved) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }
      if (step === PURCHASE_MODAL_STEPS.create) {
        setNewUserSignedIn(true);
        if (values.TimeZoneId === undefined || values.TimeZoneId === 'Select Timezone') {
          return;
        }
        const returnedRegisterAction = await completeRegister({
          ...values,
          userView: UserRoles.client,
        })(dispatch);
        if (
          returnedRegisterAction?.type !== REGISTER_FAILURE &&
          returnedRegisterAction?.type !== CONTINUE_REGISTER_FAILURE
        ) {
          if (
            (contribution?.isCustomEnrollmentFormAdded ||
              (contribution?.isPhoneNumberAdded && contribution?.enrollmentFormViewModel?.questions?.length > 0)) &&
            !enrollmentFormSubmitted &&
            step !== PURCHASE_MODAL_STEPS.enrollmentForm
          ) {
            setStep(PURCHASE_MODAL_STEPS.enrollmentForm);
            return false;
          }
          if (isElectronicSignatureActive && Signature) {
            const signSaved = await isSignSaved(Signature);
            if (signSaved) {
              return formRef.current?.handleSubmit();
            } else {
              return false;
            }
          }

          return formRef.current?.handleSubmit();
        }
        return false;
      }
      if (step === PURCHASE_MODAL_STEPS.joinCreate) {
        setNewUserSignedIn(true);
        dispatch({
          type: 'PURCHASE_DUMMY',
          payload: false,
        });
        if (values.TimeZoneId === undefined || values.TimeZoneId === 'Select Timezone') {
          return;
        }
        const returnedRegisterAction = await completeRegister({
          ...values,
          userView: UserRoles.client,
        })(dispatch);
        if (
          returnedRegisterAction?.type !== REGISTER_FAILURE &&
          returnedRegisterAction?.type !== CONTINUE_REGISTER_FAILURE
        ) {
          if (
            (contribution?.isCustomEnrollmentFormAdded ||
              (contribution?.isPhoneNumberAdded && contribution?.enrollmentFormViewModel?.questions?.length > 0)) &&
            !enrollmentFormSubmitted &&
            step !== PURCHASE_MODAL_STEPS.joinEnrollmentForm
          ) {
            setStep(PURCHASE_MODAL_STEPS.joinEnrollmentForm);
            return false;
          }
          if (isElectronicSignatureActive && Signature) {
            const signSaved = await isSignSaved(Signature);
            if (signSaved) {
              joinContribution({ id, accessCode: isInviteToJoin })
                .then(() => {
                  dispatch(
                    fetchContributionActions.success({
                      ...contribution,
                      isPurchased: true,
                      purchaseStatus: 'succeeded',
                      subscriptionStatus: { status: 'active' },
                    }),
                  );
                  dispatch({
                    type: 'PURCHASE_DUMMY',
                    payload: true,
                  });
                })
                .then(() => {
                  // onJoin(true);
                });
            } else {
              return false;
            }
          }
          if (contribution.customWaiverId != null && isElectronicSignatureActive) {
            if (step != PURCHASE_MODAL_STEPS.init && step != PURCHASE_MODAL_STEPS.join) {
              if (formRef.current.isValid) {
                getWaiverForm();
              }
            } else {
              stepVerifier(formRef.current.values);
            }
          } else {
            joinContribution({ id, accessCode: isInviteToJoin })
              .then(() => {
                dispatch(
                  fetchContributionActions.success({
                    ...contribution,
                    isPurchased: true,
                    purchaseStatus: 'succeeded',
                    subscriptionStatus: { status: 'active' },
                  }),
                );
                dispatch({
                  type: 'PURCHASE_DUMMY',
                  payload: true,
                });
              })
              .then(() => {
                // onJoin(true);
              });
          }

          if (
            paymentOptions != PAYMENT_OPTIONS.FREESESSIONPACKAGE &&
            type != ContributionType.contributionOneToOne &&
            !isInviteToJoin
          ) {
            joinContribution({ id, accessCode: isInviteToJoin })
              .then(() => {
                dispatch(
                  fetchContributionActions.success({
                    ...contribution,
                    isPurchased: true,
                    purchaseStatus: 'succeeded',
                    subscriptionStatus: { status: 'active' },
                  }),
                );
                dispatch({
                  type: 'PURCHASE_DUMMY',
                  payload: true,
                });
              })
              .then(() => {
                // onJoin(true);
              });
          }
        }
        return false;
      }
      if (step === PURCHASE_MODAL_STEPS.login) {
        const { Email, Password, otp } = values;
        const returnedLoginAction = await login(Email, Password, null, null, null, null, null, null, otp)(dispatch);
        if (returnedLoginAction?.type !== LOG_IN_FAILURE) {
          // we shouldn't redirect in the login process, redirect only after purchasing
          // the return url for successful and unsuccessful payment is set in the api when creating stripe checkout
          // await handleProceedPurchaseStatus();
          if (
            (contribution?.isCustomEnrollmentFormAdded ||
              (contribution?.isPhoneNumberAdded && contribution?.enrollmentFormViewModel?.questions?.length > 0)) &&
            !enrollmentFormSubmitted &&
            step !== PURCHASE_MODAL_STEPS.enrollmentForm
          ) {
            setStep(PURCHASE_MODAL_STEPS.enrollmentForm);
            return false;
          }
          if (isElectronicSignatureActive && Signature) {
            const signSaved = await isSignSaved(Signature);
            if (signSaved) {
              return formRef.current?.handleSubmit();
            } else {
              return false;
            }
          }

          return formRef.current?.handleSubmit();
        }

        const { payload } = returnedLoginAction || {};

        setLoginErrorMessage(payload?.message);

        return false;
      }
      if (step === PURCHASE_MODAL_STEPS.joinLogin) {
        const { Email, Password, otp } = values;
        const returnedLoginAction = await login(
          Email,
          Password,
          null,
          null,
          null,
          null,
          true,
          contribution?.userId,
          otp,
        )(dispatch);
        if (returnedLoginAction?.type !== LOG_IN_FAILURE) {
          if (
            (contribution?.isCustomEnrollmentFormAdded ||
              (contribution?.isPhoneNumberAdded && contribution?.enrollmentFormViewModel?.questions?.length > 0)) &&
            !enrollmentFormSubmitted &&
            step !== PURCHASE_MODAL_STEPS.joinEnrollmentForm
          ) {
            setStep(PURCHASE_MODAL_STEPS.joinEnrollmentForm);
            return false;
          }
          if (isElectronicSignatureActive && Signature) {
            const signSaved = await isSignSaved(Signature);
            if (signSaved) {
              joinContribution({ id, accessCode: isInviteToJoin || queryCode })
                .then(() => {
                  dispatch(
                    fetchContributionActions.success({
                      ...contribution,
                      isPurchased: true,
                      purchaseStatus: 'succeeded',
                      subscriptionStatus: { status: 'active' },
                    }),
                  );
                })
                .then(() => {
                  handleProceedPurchaseStatus();
                  return formRef.current?.handleSubmit();
                });
            } else {
              return false;
            }
          }
          if (
            paymentOptions != PAYMENT_OPTIONS.FREESESSIONPACKAGE &&
            type != ContributionType.contributionOneToOne &&
            !isInviteToJoin
          ) {
            joinContribution({ id, accessCode: isInviteToJoin })
              .then(() => {
                dispatch(
                  fetchContributionActions.success({
                    ...contribution,
                    isPurchased: true,
                    purchaseStatus: 'succeeded',
                    subscriptionStatus: { status: 'active' },
                  }),
                );
              })
              .then(() => {
                handleProceedPurchaseStatus();
                return formRef.current?.handleSubmit();
              });
          } else if (
            paymentOptions.includes(PAYMENT_OPTIONS.FREESESSIONPACKAGE) &&
            type === ContributionType.contributionOneToOne &&
            isInviteToJoin &&
            contribution.customWaiverId != null
          ) {
            return formRef.current?.handleSubmit();
          } else if (
            paymentOptions.includes(PAYMENT_OPTIONS.FREESESSIONPACKAGE) &&
            type === ContributionType.contributionOneToOne &&
            isInviteToJoin &&
            contribution.customWaiverId === null
          ) {
            return true;
          }
        }
        return false;
      }

      const isExistEmail = await checkEmail(values[ACCOUNT_FORM_FIELDS.email]);
      setallowpassword(isExistEmail);

      if (isExistEmail) {
        if (contribution?.smsPermissionsPerContribution?.SessionReminder === true) {
          setshowPhoneNumberFields(false);
        }
        if (
          isExistEmail.phNumberRequired === true &&
          contribution?.smsPermissionsPerContribution?.SessionReminder === true
        ) {
          setshowPhoneNumberFields(true);
        }
        if (isInviteToJoin || queryCode) {
          setLastStep(step);
          setStep(PURCHASE_MODAL_STEPS.joinLogin);
        } else {
          setLastStep(step);
          setStep(PURCHASE_MODAL_STEPS.login);
        }
      } else if (isInviteToJoin || queryCode) {
        setLastStep(step);
        setStep(PURCHASE_MODAL_STEPS.joinCreate);
      } else {
        setLastStep(step);
        setStep(PURCHASE_MODAL_STEPS.create);
      }
      return false;
    },
    [
      user,
      step,
      checkEmail,
      isInviteToJoin,
      dispatch,
      id,
      query.code,
      contribution,
      // onJoin,
      handleProceedPurchaseStatus,
    ],
  );

  // const stepVerifier = useCallback(
  //   async values => {
  //     if (!isEmpty(user)) {
  //       return true;
  //     }
  //     if (step === PURCHASE_MODAL_STEPS.create) {
  //       const returnedRegisterAction = await completeRegister({ ...values, userView: UserRoles.client })(dispatch);
  //       if (
  //         returnedRegisterAction?.type !== REGISTER_FAILURE &&
  //         returnedRegisterAction?.type !== CONTINUE_REGISTER_FAILURE
  //       ) {
  //         return formRef.current?.handleSubmit();
  //       }
  //       return false;
  //     }
  //     if (step === PURCHASE_MODAL_STEPS.joinCreate) {
  //       const returnedRegisterAction = await completeRegister({ ...values, userView: UserRoles.client })(dispatch);
  //       if (
  //         returnedRegisterAction?.type !== REGISTER_FAILURE &&
  //         returnedRegisterAction?.type !== CONTINUE_REGISTER_FAILURE
  //       ) {
  //         joinContribution({ id, accessCode: isInviteToJoin }).then(() => {
  //           dispatch(
  //             fetchContributionActions.success({
  //               ...contribution,
  //               isPurchased: true,
  //               purchaseStatus: 'succeeded',
  //               subscriptionStatus: { status: 'active' },
  //             }),
  //           );
  //         });
  //       }
  //       return false;
  //     }

  //     if (step === PURCHASE_MODAL_STEPS.login) {
  //       const { Email, Password } = values;
  //       const returnedLoginAction = await login(Email, Password)(dispatch);
  //       if (returnedLoginAction?.type !== LOG_IN_FAILURE) {
  //         if (!oneToOne) {
  //           handleProceedPurchaseStatus();
  //         }
  //         return formRef.current?.handleSubmit();
  //       }
  //       return false;
  //     }
  //     if (step === PURCHASE_MODAL_STEPS.joinLogin) {
  //       const { Email, Password } = values;
  //       const returnedLoginAction = await login(Email, Password)(dispatch);
  //       if (returnedLoginAction?.type !== LOG_IN_FAILURE) {
  //         joinContribution({ id, accessCode: isInviteToJoin })
  //           .then(() => {
  //             dispatch(
  //               fetchContributionActions.success({
  //                 ...contribution,
  //                 isPurchased: true,
  //                 purchaseStatus: 'succeeded',
  //                 subscriptionStatus: { status: 'active' },
  //               }),
  //             );
  //           })
  //           .then(() => {
  //             if (!oneToOne) {
  //               handleProceedPurchaseStatus();
  //             }
  //             return formRef.current?.handleSubmit();
  //           });
  //       }
  //       return false;
  //     }

  //     const isExistEmail = await checkEmail(values[ACCOUNT_FORM_FIELDS.email]);
  //     if (isExistEmail) {
  //       if (isInviteToJoin) {
  //         setStep(PURCHASE_MODAL_STEPS.joinLogin);
  //       } else {
  //         setStep(PURCHASE_MODAL_STEPS.login);
  //       }
  //     } else if (isInviteToJoin) {
  //       setStep(PURCHASE_MODAL_STEPS.joinCreate);
  //     } else {
  //       setStep(PURCHASE_MODAL_STEPS.create);
  //     }
  //     return false;
  //   },
  //   [checkEmail, dispatch, handleProceedPurchaseStatus, oneToOne, step, user, id],
  // );

  const stripe = useStripe();
  const elements = useElements();
  const { request, loading } = useHttp();
  // const [typeOfPayment, setTypeOfPayment] = useState(
  //   oneToOne && paymentOptions.includes(PAYMENT_OPTIONS.PER_SESSION)
  //     ? PAYMENT_OPTIONS.PER_SESSION
  //     : paymentOptions.sort()[0],
  // );

  const [summary, setSummary] = useState(null);
  const [coupan_id, setcoupan_id] = useState(null);
  const summaryRef = useRef();
  summaryRef.current = summary;
  const [name, setName] = useState(null);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [error, setError] = useState(null);

  const handlePayResponse = useCallback(
    response => {
      setLoadingPayment(false);

      if (response.error) {
        setError(response.error.message);
      } else {
        onSubmit();
      }
    },
    [onSubmit],
  );

  // Payment method
  const payWith3DSecure = useCallback(
    (...args) => {
      setLoadingPayment(true);

      stripe
        .confirmCardPayment(...args)
        .then(handlePayResponse)
        .catch(console.dir);
    },
    [stripe, handlePayResponse],
  );

  // Entire payment flow: prepareEntire => payEntireCourse => confirm 3d secure
  const payEntireCourse = useCallback(
    data => {
      const { clientSecret } = data;
      const card = elements.getElement(CardNumberElement);

      payWith3DSecure(clientSecret, {
        payment_method: {
          card,
          billing_details: { name },
        },
      });
    },
    [elements, name, payWith3DSecure],
  );

  // TODO: change namings
  const prepareEntire = useCallback(
    data => {
      let apiUrl = '/api/purchase/course/checkout';
      if (oneToOne) {
        apiUrl = '/api/purchase/one-to-one';
        data = { ...data, isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded, priceId: priceId };
        if (isMonthlySessionSubscription) {
          apiUrl += '/monthly-session-subscription';
        } else if (isPackage) {
          apiUrl += '/package';
        }
      }
      let reqData;

      if (isCodeToJoin) {
        reqData = {
          contributionId: id,
          AvailabilityTimeId: singleSessionInvite.AvailabilityTimeId,
          offset: singleSessionInvite.offset,
          accessCode: singleSessionInvite.accessCode,
          paymentOption: singleSessionInvite.priceOption,
          couponId: couponCode,
          priceId: priceId,
          createSingleSession: true,
        };
        request(apiUrl, 'POST', reqData)
          // .then(payEntireCourse)
          .then(res => {
            // handle 100% discount without checkout
            if (res === '100discount' || isInviteToJoin || isCodeToJoin) {
              // quick solution:redirect; todo: update state with purchased contribution and hide purchase modal
              setTimeout(() => {
                window.location.replace(`/contribution-view/${id}/sessions`);
              }, 1000);
              // handleProceedPurchaseStatus();
              // setLoadingPayment(false);
            } else {
              if (contribution?.paymentType === 'Advance') {
                return redirectTo(res);
              } else {
                return stripe.redirectToCheckout({ sessionId: res });
              }
            }
            dispatch(contributionActions.setSingleCode(null));
          })
          .catch(e => {
            if (e?.response?.data.includes('Your are not booked for this session or this session is already booked.')) {
              setErrorModal(true);
            }
            if (e?.response?.status === 400) {
              if (isInviteToJoin || isCodeToJoin) {
                window.location.reload();
              } else {
                // return setIsAlreadyPuchased(true);
              }
            }
            console.dir(e);
          });
      }

      request(apiUrl, 'POST', isCodeToJoin ? reqData : data)
        // .then(payEntireCourse)
        .then(res => {
          // handle 100% discount without checkout
          if (res === '100discount' || isInviteToJoin) {
            // quick solution:redirect; todo: update state with purchased contribution and hide purchase modal
            if (contribution.isThankyouPageAdded === false) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            // handleProceedPurchaseStatus();
            // setLoadingPayment(false);
          } else {
            if (contribution?.paymentType === 'Advance') {
              return redirectTo(res);
            } else {
              return stripe.redirectToCheckout({ sessionId: res });
            }
          }
        })
        .catch(e => {
          if (e?.response?.status === 400) {
            if (isInviteToJoin && contribution.isThankyouPageAdded) {
              window.location.reload();
            } else {
              // return setIsAlreadyPuchased(true);
            }
          }
          console.dir(e);
        });
    },
    [request, isMonthlySessionSubscription /*, payEntireCourse*/],
  );

  // Split payments flow: createTokenForSplitPayments => attachPaymentMethodByToken => subscribe => confirm 3d secure
  const subscribe = useCallback(
    ({ paymentMethodId }) => {
      const data = {
        paymentMethodId,
        paymentOptions: isMonthlySessionSubscription ? 'MonthlySessionSubscription' : 'SplitPayments',
        paymentOption: isMonthlySessionSubscription ? 'MonthlySessionSubscription' : 'SplitPayments',
        contributionId: contribution.id,
        couponId: coupan_id ? coupan_id : summaryRef?.current?.coupon?.id,
      };

      const purchaseType = oneToOne ? ContributionPurchaseType.oneToOne : ContributionPurchaseType.course;
      const paymentOption = isMonthlySessionSubscription ? '/monthly-session-subscription' : '';
      const paymentUrl = `/api/purchase/${purchaseType}${paymentOption}`;

      request(paymentUrl, 'POST', data)
        .then(res => {
          if (isMonthlySessionSubscription) {
            payWith3DSecure(res.clientSecret);
          }
        })
        .catch(console.dir);
    },
    [request, contribution.id, payWith3DSecure, oneToOne, isMonthlySessionSubscription],
  );

  const attachPaymentMethodByToken = useCallback(
    cardToken => {
      request('/api/payment/attach-customer-payment-method-token', 'POST', {
        cardToken,
        contributionId: contribution.id,
      })
        .then(subscribe)
        .catch(console.dir);
    },
    [request, subscribe],
  );

  // const createPackageIntentOnStripe = params => {
  //   return new Promise(async resolve => {
  //     const paymentDataResponse = await request('/api/purchase/one-to-one/pkg', 'POST', params);
  //     resolve(paymentDataResponse);
  //   });
  // };

  // TODO: change this to use stripe checkout
  const createTokenForSplitPayments = useCallback(() => {
    const card = elements.getElement(CardNumberElement);
    stripe.createToken(card).then(res => {
      if (!res.error) {
        attachPaymentMethodByToken(res.token.id);
      }
    });
  }, [stripe, elements, attachPaymentMethodByToken]);
  const updateUserCall = async () => {
    const updatedUser = {
      ...user,
      id: user.id,
      stateCode: formRef.current.values.stateCode,
      timeZoneId: formRef.current.values.TimeZoneId,
      countryId: formRef.current.values.countryId,
    };
    await editUserProfile(user.id, updatedUser).then(async res => {
      let u = {
        ...user,
        countryId: res.user.countryId,
        timeZoneId: res.user.timeZoneId,
        stateCode: res.user.stateCode,
      };
      dispatch(updateUser(u));
    });
  };
  // Submitting form when user clicks on purchase button
  const handleSubmit = useCallback(
    async values => {
      if (getSubmitButtonTitle()?.includes('Apply')) {
        const code = isInviteToJoin || priceId;
        redirectTo(`/application-form/${id}${code ? `/${code}` : ''}`);
        return;
      }
      formRef.current.setTouched({});
      const isCanProceed = await stepVerifier(values);

      if (!isCanProceed) {
        return;
      }
      if (contribution?.smsPermissionsPerContribution?.SessionReminder === true) {
        const phoneNumberAdded = checkPhoneNumber();
        if (!phoneNumberAdded) {
          setshowPhoneNumberFields(true);
          setLoadingPayment(false);
          return;
        }
      }
      if (
        contribution.paymentType === 'Simple' &&
        contribution.taxType != 'No' &&
        isInviteToJoin === null &&
        newUserSignedIn === false &&
        !isMonthlySessionSubscription &&
        ((contribution.paymentInfo.paymentOptions.length === 1 &&
          contribution.paymentInfo.paymentOptions.includes('Free')) ||
          (contribution.paymentInfo.paymentOptions.length === 1 &&
            contribution.paymentInfo.paymentOptions.includes('FreeSessionsPackage')) ||
          (contribution.paymentInfo.paymentOptions.length === 2 &&
            contribution.paymentInfo.paymentOptions.includes('FreeSessionsPackage') &&
            contribution.paymentInfo.paymentOptions.includes('Free'))) === false
      ) {
        const isCheckCountry = await checkCountry(values);
        if (!isCheckCountry) {
          setLoadingPayment(false);
          return;
        } else {
          await updateUserCall();
        }
      }
      if (contribution.customWaiverId != null && isElectronicSignatureActive) {
        if (
          isInviteToJoin &&
          !isEmpty(user) &&
          contribution?.isElectronicSignatureActive === true &&
          contribution.customWaiverId != null &&
          contribution.type === ContributionType.contributionOneToOne &&
          !isPackage
        ) {
        } else {
          if (
            location.pathname.includes('apply-contribution-view') &&
            contribution.type === ContributionType.contributionOneToOne &&
            !isPackage &&
            contribution.customWaiverId != null
          ) {
          } else {
            if (isPackage) {
              getWaiverForm();
            } else if (isMonthlySessionSubscription) {
              getWaiverForm();
            }
          }
        }
      } else {
        if (proseedHandlePurchase && !isPackage) {
          return proseedHandlePurchase(summary?.coupon?.id ? summary?.coupon?.id : null);
        }
        setName(values.Name);
        setError(null);
        if (oneToOne) {
          if (isMonthlySessionSubscription && monthlySessionSubscription) {
            createTokenForSplitPayments();
            const data = {
              paymentOption: isMonthlySessionSubscription ? 'MonthlySessionSubscription' : 'SplitPayments',
              contributionId: contribution.id,
              couponId: summaryRef?.current?.coupon?.id,
            };
            prepareEntire(data);
            return;
          } /*else if (isPackage) {
            const data = {
              contributionId: contribution.id,
              couponId: summaryRef?.current?.coupon?.id,
            };
            prepareEntire(data);
            return;
          }*/ else if (
            isPackage &&
            sessionPackageStyled &&
            typeOfPayment === PAYMENT_OPTIONS.FREESESSIONPACKAGE
          ) {
            const paramData = {
              contributionId: id,
              accessCode: isInviteToJoin,
              isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
              isPhoneNumberAdded: contribution.isPhoneNumberAdded,
              isCoachNumberAdded: contribution.isCoachNumberAdded,
              // createSingleSession: false,
              priceId: priceId,
            };
            try {
              await request('/api/Purchase/one-to-one/pkg', 'POST', paramData);
              if (contribution.isThankyouPageAdded === false && isInviteToJoin === null) {
                setTimeout(() => {
                  if (contribution?.clientRedirectLink) {
                    return history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
                  } else {
                    return history.push(`/contribution-view/${id}/sessions`);
                  }
                }, 2000);
              }
            } catch (err) {
              handleOpenPackagePurchased();
            }
            dispatch(
              fetchContributionActions.success({
                ...contribution,
                isPurchased: true,
                purchaseStatus: 'succeeded',
                subscriptionStatus: { status: 'active' },
              }),
            );
            // history.push(`/contribution-view/${id}/sessions`);
            if (contribution?.clientRedirectLink) {
              history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
            } else {
              history.push(`/contribution-view/${id}/sessions`);
            }
            if (contribution.isThankyouPageAdded === false) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            if (contribution?.clientRedirectLink) {
              history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
            } else {
              history.push(`/contribution-view/${id}/sessions`);
            }
            // return history.push(`/contribution-view/${id}/sessions`);
            // payEntireCourse(paymentDataOneToOne);
            // return;
          } else if (isPackage && sessionPackageStyled) {
            let paramData;
            if (summary?.coupon?.id != null) {
              paramData = {
                contributionId: id,
                couponId: summary?.coupon?.id ? summary?.coupon?.id : null,
                createSingleSession: false,
                isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
                isPhoneNumberAdded: contribution.isPhoneNumberAdded,
                isCoachNumberAdded: contribution.isCoachNumberAdded,
                priceId: priceId,
              };
            } else {
              paramData = {
                contributionId: id,
                accessCode: isInviteToJoin,
                isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
                isPhoneNumberAdded: contribution.isPhoneNumberAdded,
                isCoachNumberAdded: contribution.isCoachNumberAdded,
                priceId: priceId,
              };
            }
            try {
              const res = await request('/api/Purchase/one-to-one/pkg', 'POST', paramData);
              if (isInviteToJoin != null) {
                if (contribution?.clientRedirectLink) {
                  history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
                } else {
                  history.push(`/contribution-view/${id}/sessions`);
                }
              }
              if (res === '100discount') {
                window.location.reload();
              } else if (contribution?.paymentType === 'Advance') {
                return redirectTo(res);
              } else {
                return stripe.redirectToCheckout({ sessionId: res });
              }
            } catch (err) {}

            dispatch(
              fetchContributionActions.success({
                ...contribution,
                isPurchased: true,
                purchaseStatus: 'succeeded',
                subscriptionStatus: { status: 'active' },
              }),
            );
            if (contribution?.clientRedirectLink) {
              history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
            } else {
              history.push(`/contribution-view/${id}/sessions`);
            }
            // history.push(`/contribution-view/${id}/sessions`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);

            // payEntireCourse(paymentDataOneToOne);
            // return;
          }
          if (!isPackage) {
            prepareEntire({
              ...paymentDataOneToOne,
              couponId: summaryRef?.current?.coupon?.id || couponCode,
              createSingleSession: true,
              priceId: priceId,
            });
          }
        }

        If(typeOfPayment === 'EntireCourse' || typeOfPayment === 'SplitPayments')
          .then(
            mapTo({
              contributionId: contribution.id,
              // paymentOptions: typeOfPayment,
              paymentOption: typeOfPayment,
              couponId: summaryRef?.current?.coupon?.id,
            }),
          )
          .then(prepareEntire)
          .else(createTokenForSplitPayments);
      }
    },
    [
      stepVerifier,
      proseedHandlePurchase,
      oneToOne,
      typeOfPayment,
      contribution.id,
      prepareEntire,
      createTokenForSplitPayments,
      // payEntireCourse,
      paymentDataOneToOne,
      setName,
      smsReminderCheckBox,
      phoneNumberField,
    ],
  );

  // TODO : check if needed and fix
  useEffect(() => {
    if (payment === PAYMENTS_STATUS.SUCCESS) {
      setLoadingPayment(false);
      onSubmit();
    }
  }, [payment]);

  // Get summary for payment
  useEffect(() => {
    setError(null);
    getSummary();
  }, [typeOfPayment, contribution.id, oneToOne]);

  const getSubmitButtonTitle = () => {
    const applicationFormAttachedTitle = !isEmpty(user) && isInviteToJoin ? 'Reserve' : 'Next';
    if ((isEmpty(user) && step === PURCHASE_MODAL_STEPS.init) || step === PURCHASE_MODAL_STEPS.join) {
      return applicationRequiredButNotApproved ? 'Apply Before Joining' : applicationFormAttachedTitle;
    }
    if (isApplyContributionView && isApplicationResponsePending) {
      return 'Apply Now';
    }
    return PURCHASE_MODAL_TITLES[type].submit;
  };
  const getSummary = coupon => {
    let paymentType = typeOfPayment;
    // let paymentType = `${isPackage ? 'SessionsPackage' : typeOfPayment}`;
    // paymentType = `${isMonthlySessionSubscription ? 'MonthlySessionSubscription' : paymentType}`;

    const REQUEST_MAPPING = {
      [ContributionType.contributionOneToOne]: purchaseService.getOnToOnePaymentInfo,
      [ContributionType.contributionCourse]: purchaseService.getCoursePaymentInfo,
      [ContributionType.contributionMembership]: purchaseService.getMembershipPaymentInfo,
      [ContributionType.contributionCommunity]: purchaseService.getCommunityPaymentInfo,
    };
    const paymentFetch =
      paymentType == 'PerSession' || paymentType == 'SessionsPackage'
        ? priceId?.includes('p_')
          ? priceId
          : null
        : coupon?.id;
    const getPaymentData = REQUEST_MAPPING[contribution.type];

    getPaymentData(contribution.id, paymentFetch, isModal ? 'PerSession' : paymentType, coupon?.id)
      .then(data => {
        setSummary({ ...data, coupon: coupon });
        if (user && coupon) {
          updatePackageIntent({
            contributionId: contribution.id,
            couponId: coupon?.id || couponCode,
          });
        }
      })
      .catch(console.dir);
  };

  const handleRedeem = () => {
    const {
      current: { values },
    } = formRef;
    if (values?.Coupon?.length > 0) {
      setCouponError(false);
      request(`/Coupons/ValidateByName/${values.Coupon}/${contribution.id}/${typeOfPayment}`, 'GET')
        .then(res => {
          if (res?.id === undefined) {
            setCouponError(true);
          }
          dispatch(contributionActions.setCouponCode(res.id));
          if (res?.percentAmount > 0 || res?.discountAmount > 0) {
            setcoupan_id(res.id);
            getSummary(res);
          }
        })
        .catch(() => {
          setCouponError(true);
        });
    }
  };

  let colorToUse = determineColorToUse(contribution);
  const PrimaryColor = colorToUse?.PrimaryColorCode;

  const saveSignature = async val => {
    let returnval = false;
    const formData = new FormData();
    const sign = dataURLtoFile(val);
    formData.append('file', sign);
    const userIP = await getIpGlobal();
    await saveSignoffData(formData, id, userIP)
      .then(res => {
        if (res === 'Signoff data succesfully saved.') {
          returnval = true;
        }
      })
      .catch(err => {});
    return returnval;
  };

  const setStepValue = useCallback(
    val => {
      setStep(val);
    },
    [step],
  );

  const cardInitialValues = useMemo(() => {
    let val;
    if (isPackage && sessionPackageStyled) {
      val = {
        [ACCOUNT_FORM_FIELDS.confirmEmail]: '',
        [ACCOUNT_FORM_FIELDS.email]: '',
        [ACCOUNT_FORM_FIELDS.password]: '',
        [ACCOUNT_FORM_FIELDS.firstName]: '',
        [ACCOUNT_FORM_FIELDS.lastName]: '',
        [DISCOUNT_CODE_FIELDS.coupon]: '',
        [ACCOUNT_FORM_FIELDS.signature]: null,
      };
    } else {
      val = {
        Name: '',
        cardNumber: false,
        cardExpired: false,
        cardCVC: false,
        [ACCOUNT_FORM_FIELDS.confirmEmail]: '',
        [ACCOUNT_FORM_FIELDS.email]: '',
        [ACCOUNT_FORM_FIELDS.password]: '',
        [ACCOUNT_FORM_FIELDS.firstName]: '',
        [ACCOUNT_FORM_FIELDS.lastName]: '',
        [DISCOUNT_CODE_FIELDS.coupon]: '',
        [ACCOUNT_FORM_FIELDS.signature]: null,
      };
    }
    return val;
  }, [sessionPackageStyled]);

  useEffect(() => {
    if (contribution?.isPurchased) {
      setEnrollmentFormSubmitted(true);
      setTimeout(() => {
        firstRender.current = false;
      }, 200);
    }
  }, [contribution]);

  useEffect(() => {
    if (enrollmentFormSubmitted && isEmpty(user)) {
      // eslint-disable-next-line no-unused-expressions
      formRef.current?.handleSubmit();
      setStep(PURCHASE_MODAL_STEPS.loggedIn);
    }
  }, [enrollmentFormSubmitted]);

  const saveUserSignature = async values => {
    const formData = new FormData();
    const sign = dataURLtoFile(values.clientSignature);
    setWaiverData({
      ...waiverData,
      clientName: values.clientName,
    });
    formData.append('file', sign);
    setIsSigned(formData);
    setIsWaiverVisible(false);
  };
  return (
    <StyledPurchaseModalContainer clientPreviewMode={clientPreviewMode}>
      <Formik
        initialValues={cardInitialValues}
        validationSchema={getPurchaseValidationSchema(step, isMonthlySessionSubscription && monthlySessionSubscription)}
        // validationSchema={isInviteToJoin && paymentOptions === PAYMENT_OPTIONS.FREESESSIONPACKAGE?null:getPurchaseValidationSchema(step, isMonthlySessionSubscription && monthlySessionSubscription)}
        onSubmit={handleSubmit}
        innerRef={formRef}
      >
        {({ handleChange, handleBlur, errors, touched, setTouched, values, setFieldValue }) => {
          return (
            <>
              <CustomPurchaseModalForm
                isCodeToJoin={isCodeToJoin}
                isInviteToJoin={isInviteToJoin}
                setTouched={setTouched}
                submitTitle={getSubmitButtonTitle()}
                loading={loading}
                summary={summary}
                values={values}
                formRef={formRef}
                typeOfPayment={typeOfPayment}
                stepVerifier={stepVerifier}
                isPackage={isPackage}
                isMonthlySessionSubscription={isMonthlySessionSubscription}
                perSessionStyled={perSessionStyled}
                sessionPackageStyled={sessionPackageStyled}
                monthlySessionSubscription={monthlySessionSubscription}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                handleRedeem={handleRedeem}
                couponError={couponError}
                isCouponAvailable={isCouponAvailable}
                setSmsReminderCheckBox={setSmsReminderCheckBox}
                smsReminderCheckBox={smsReminderCheckBox}
                setshowPhoneNumberFields={setshowPhoneNumberFields}
                showPhoneNumberFields={showPhoneNumberFields}
                setloginStep={setloginStep}
                loginStep={loginStep}
                setPhoneNumberField={setPhoneNumberField}
                phoneNumberField={phoneNumberField}
                errors={errors}
                touched={touched}
                error={error}
                selectedTimeZone={selectedTimeZone}
                setIsSigned={setIsSigned}
                isSigned={isSigned}
                setShowTerms={setShowTerms}
                customWaiverId={contribution?.customWaiverId}
                step={step}
                isModal={isModal}
                paymentIntentCreated={paymentDataOneToOne?.created}
                sessionLifeTimeSeconds={paymentDataOneToOne?.sessionLifeTimeSeconds}
                onCheckoutSessionExpired={() => onClose(false)}
                anyPaymentOptionEnabled={anyPaymentOptionEnabled}
                showErrorMessage={showErrorMessage}
                disableSubmitBtn={
                  (isApplyContributionView && isApplicationResponsePending) ||
                  loading ||
                  loadingPayment ||
                  isLoadingEmail ||
                  isLoadingAccount
                }
                setStepValue={setStepValue}
                handleSubmit={handleSubmit}
                setEnrollmentFormSubmitted={setEnrollmentFormSubmitted}
                easyBooking={easyBookingState}
                rescheduleSession={rescheduleSession}
                setRescheduleSession={setRescheduleSession}
                packageSessionBooking={packageSessionBooking}
                setShowModal={setShowModal}
              />
            </>
          );
        }}
      </Formik>
      <ModalTermsAndConditions showTerms={showTerms} onCancel={() => setShowTerms(false)} />
      <SuccessfulPurchaseModal isOpen={isSuccessPurchaseModalOpen} handleClose={handleSuccessModalClose} />
      <FailedPurchaseModal isOpen={isFailedPurchaseModalOpen} handleClose={handleFailedModalClose} />
      {showUnableJoin && (
        <Modal
          title="Unable to join"
          isOpen={showUnableJoin}
          submitTitle="Close"
          hiddenCancel
          onCancel={() => {
            setshowUnableJoin(false);
          }}
          dontCancelOnSideClick
          onSubmit={() => {
            setshowUnableJoin(false);
          }}
          style={{ zIndex: '2000' }}
        >
          <p>Please use another email - you entered the account holder email of this service.</p>
        </Modal>
      )}
      {isAlreadyPuchased && (
        <Modal
          isOpen
          onCancel={handleCloseAlreadyPurchased}
          onSubmit={handleCloseAlreadyPurchased}
          title="Purchased service"
          hiddenCancel
          PrimaryColor={PrimaryColor}
        >
          <LabelText>You have already purchased this service </LabelText>
        </Modal>
      )}
      <Modal
        isOpen={isFreePackageFailed}
        onCancel={handleClosePackagePurchased}
        onSubmit={handleClosePackagePurchased}
        title="Free Package Purchase Failed"
        hiddenCancel
        PrimaryColor={PrimaryColor}
      >
        <LabelText>Unable to purchase sessions package until you have incomplete package</LabelText>
      </Modal>
      {errorModal && (
        <Modal
          isOpen={errorModal}
          onCancel={() => {
            setErrorModal(false);
          }}
          onSubmit={() => {
            setErrorModal(false);
          }}
          title=""
          hiddenCancel
          submitTitle="Ok"
        >
          <LabelText style={{ color: contribution?.isDarkModeEnabled ? 'white' : 'black' }}>
            You are not booked for this session or this session is already booked.
          </LabelText>
        </Modal>
      )}
      {isWaiverVisible && (
        <CreateCustomWaiver
          isOpen={isWaiverVisible}
          onSubmit={values =>
            saveUserSignature(values).then(async () => {
              isSignSaved(values.clientSignature);

              if (oneToOne) {
                if (isMonthlySessionSubscription && monthlySessionSubscription) {
                  createTokenForSplitPayments();
                  // const data = {
                  //   paymentOption: isMonthlySessionSubscription ? 'MonthlySessionSubscription' : 'SplitPayments',
                  //   contributionId: contribution.id,
                  //   couponId: summaryRef?.current?.coupon?.id,
                  // };
                  // prepareEntire(data);
                  return;
                } /*else if (isPackage) {
                  const data = {
                    contributionId: contribution.id,
                    couponId: summaryRef?.current?.coupon?.id,
                  };
                  prepareEntire(data);
                  return;
                }*/ else if (
                  isPackage &&
                  sessionPackageStyled &&
                  typeOfPayment === PAYMENT_OPTIONS.FREESESSIONPACKAGE
                ) {
                  const paramData = {
                    contributionId: id,
                    accessCode: isInviteToJoin,
                    isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
                    isPhoneNumberAdded: contribution.isPhoneNumberAdded,
                    isCoachNumberAdded: contribution.isCoachNumberAdded,
                    priceId: priceId,
                    // createSingleSession: false,
                  };
                  try {
                    const res = await request('/api/Purchase/one-to-one/pkg', 'POST', paramData);
                    if (contribution.isThankyouPageAdded === false && isInviteToJoin === null) {
                      setTimeout(() => {
                        if (contribution?.clientRedirectLink) {
                          history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
                        } else {
                          history.push(`/contribution-view/${id}/sessions`);
                        }
                        // return history.push(`/contribution-view/${id}/sessions`);
                      }, 2000);
                    }
                  } catch (err) {
                    handleOpenPackagePurchased();
                  }
                  dispatch(
                    fetchContributionActions.success({
                      ...contribution,
                      isPurchased: true,
                      purchaseStatus: 'succeeded',
                      subscriptionStatus: { status: 'active' },
                    }),
                  );
                  if (contribution?.clientRedirectLink) {
                    history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
                  } else {
                    history.push(`/contribution-view/${id}/sessions`);
                  }
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);

                  // payEntireCourse(paymentDataOneToOne);
                  // return;
                } else if (isPackage && sessionPackageStyled) {
                  let paramData;
                  if (summary?.coupon?.id != null) {
                    paramData = {
                      contributionId: id,
                      couponId: summary?.coupon?.id ? summary?.coupon?.id : null,
                      createSingleSession: false,
                      isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
                      isPhoneNumberAdded: contribution.isPhoneNumberAdded,
                      isCoachNumberAdded: contribution.isCoachNumberAdded,
                      priceId: priceId,
                    };
                  } else {
                    paramData = {
                      contributionId: id,
                      accessCode: isInviteToJoin,
                      isPhoneNumberEnabledSession: contribution.isPhoneNumberAdded,
                      isPhoneNumberAdded: contribution.isPhoneNumberAdded,
                      isCoachNumberAdded: contribution.isCoachNumberAdded,
                      priceId: priceId,
                    };
                  }
                  try {
                    const res = await request('/api/Purchase/one-to-one/pkg', 'POST', paramData);
                    if (res === '100discount') {
                      if (contribution.isThankyouPageAdded === false && isInviteToJoin === null) {
                        window.location.reload();
                      }
                    } else if (contribution?.paymentType === 'Advance') {
                      return redirectTo(res);
                    } else {
                      return stripe.redirectToCheckout({ sessionId: res });
                    }
                  } catch (err) {}

                  dispatch(
                    fetchContributionActions.success({
                      ...contribution,
                      isPurchased: true,
                      purchaseStatus: 'succeeded',
                      subscriptionStatus: { status: 'active' },
                    }),
                  );
                  if (contribution.isThankyouPageAdded === false && isInviteToJoin === null) {
                    if (contribution?.clientRedirectLink) {
                      history.push(`/contribution-view/${id}/${contribution?.clientRedirectLink?.toLowerCase()}`);
                    } else {
                      history.push(`/contribution-view/${id}/sessions`);
                    }
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }

                  // payEntireCourse(paymentDataOneToOne);
                  // return;
                }
                if (!isPackage) {
                  prepareEntire({
                    ...paymentDataOneToOne,
                    couponId: summaryRef?.current?.coupon?.id || couponCode,
                    createSingleSession: true,
                    priceId: priceId,
                  });
                }
              }
            })
          }
          contribution={contribution}
          waiverData={waiverData}
          isDarkModeAllowed={true}
          onCancel={() => setIsWaiverVisible(false)}
          isCreateContribution={false}
        />
      )}
    </StyledPurchaseModalContainer>
  );
};

CustomPurchaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  typeOfPayment: PropTypes.string.isRequired,
  oneToOne: PropTypes.bool,
  paymentDataOneToOne: PropTypes.shape({
    clientSecret: PropTypes.string,
  }),
  isPackage: PropTypes.bool,
  isMonthlySessionSubscription: PropTypes.bool,
  proseedHandlePurchase: PropTypes.func,
  updatePackageIntent: PropTypes.func,
  submitNow: PropTypes.bool.isRequired,
  showOnlyProseedModal: PropTypes.func,
};

CustomPurchaseModal.defaultProps = {
  oneToOne: false,
  paymentDataOneToOne: null,
  isPackage: false,
  isMonthlySessionSubscription: false,
  proseedHandlePurchase: null,
  updatePackageIntent: null,
  showOnlyProseedModal: null,
  isInviteToJoin: null,
};

export default CustomPurchaseModal;
